import { LandingConfigDto, LandingFormFieldDto } from '../dto';
import {
  DEFAULT_LANDING_CONFIG,
  LOCKED_LANDING_FIELD_KEYS,
} from './landing-defaults';

export function parseLandingContent(content: string | null): LandingConfigDto {
  if (!content) {
    return DEFAULT_LANDING_CONFIG;
  }

  try {
    const saved = JSON.parse(content) as Partial<LandingConfigDto>;
    const defaults = DEFAULT_LANDING_CONFIG;

    return {
      brand: { ...defaults.brand, ...saved.brand },
      fields: enforceLockedFields(
        saved.fields?.length ? saved.fields : defaults.fields,
      ),
      security: { ...defaults.security, ...saved.security },
      design: { ...defaults.design, ...saved.design },
      typography: { ...defaults.typography, ...saved.typography },
      footer: { ...defaults.footer, ...saved.footer },
    };
  } catch {
    return DEFAULT_LANDING_CONFIG;
  }
}

/** Forces locked fields to be visible + required, adding them if missing (configs saved before the lock). */
function enforceLockedFields(
  fields: LandingFormFieldDto[],
): LandingFormFieldDto[] {
  const result = fields.map((field) =>
    LOCKED_LANDING_FIELD_KEYS.includes(field.key)
      ? { ...field, visible: true, required: true }
      : field,
  );

  for (const key of LOCKED_LANDING_FIELD_KEYS) {
    const fallback = DEFAULT_LANDING_CONFIG.fields.find(
      (field) => field.key === key,
    );

    if (fallback && !result.some((field) => field.key === key)) {
      result.push(fallback);
    }
  }

  return result;
}
